import { SearchOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import SelectCapacitiesType from "./Elements/Select-Capacities-Type";
import Search from "antd/es/input/Search";
import SelectKnowledgeArea from "./Elements/Select-Knowledge-Area";
import SelectKnowledgeSpecialty from "./Elements/Select-Knowledge-Specialty";
import SelectKnowledgeGran from "./Elements/Select-Knowledge-Gran";
import { useState } from "react";

interface Props {
    onSearchChange: (value: string) => void,
    onSearchChangeValue : (value: string) => void,
    onSearchPressEnter :  (value: any) => void,
    onSelectCapacitiesTypeChange: (value: string) => void,
    onSelectKnowledgeSpecialty: (value: string) => void,
    onSelectKnowledgeGran: (value: string) => void,
    onSelectKnowledgeArea: (value: string) => void,
    onClearCapacityType: () => void,
    onClearKnowledgeArea: () => void,
    onClearKnowledgeGran: () => void,
    onClearKnowledgeSpecialty: () => void
}
const PRODUCTS_KEY = 'products';

const SearchCapacityForm = (props: Props) => {
    const [hideAreas, setHiddenAreas] = useState(false);
    return (
        <>
            <Row gutter={[8, 8]} style={{ width: '100%' }}>
                <Col xs={24} sm={12} md={6} lg={10}>
                    <SelectCapacitiesType style={{ width: '100%' }} size="large" defaultValue='Capacidad' onChange={(selected: any) => {
                        if (selected.collectionName?.toLowerCase() === PRODUCTS_KEY) {
                            setHiddenAreas(false);
                        } else {
                            setHiddenAreas(true);
                        }
                        props.onSelectCapacitiesTypeChange(selected);
                    }} />
                </Col>
                <Col xs={24} sm={12} md={8} lg={14} className='align-items'>
                    <Search
                        addonBefore={<SearchOutlined />}
                        className='ant-input-shadow'
                        placeholder="Escribe lo que buscas"
                        allowClear
                        onChange={(event)=>{
                            props.onSearchChangeValue(event.target.value);
                        }}
                        style={{ borderRadius: 0 }}
                        enterButton="Buscar"
                        size="large"
                        onSearch={(value)=>{
                            props.onSearchPressEnter(value);
                        }}
                    />
                </Col>
            </Row>
            {hideAreas ? (
                <Row gutter={[8, 8]} style={{ width: '100%' }}>
                    <Col xs={24} sm={12} md={6} lg={8} className='align-items'>
                        <SelectKnowledgeArea onClear={()=>{
                            props.onClearKnowledgeGran();
                        }} style={{ width: '100%' }} size="large" defaultValue='Área de conocimiento' onChange={(value: any) => {
                            props.onSelectKnowledgeArea(value);
                        }} />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={8} className='align-items'>
                        <SelectKnowledgeGran onClear={()=>{
                            props.onClearKnowledgeGran();
                        }} style={{ width: '100%' }} size="large" defaultValue='Gran Área de conocimiento' onChange={(value: any) => {
                           props.onSelectKnowledgeGran(value);
                        }} />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={8} className='align-items'>
                        <SelectKnowledgeSpecialty onClear={()=>{
                            props.onClearKnowledgeSpecialty();
                        }} size="large" defaultValue='Especialidad de conocimiento' onChange={(value: any) => {
                            props.onSelectKnowledgeSpecialty(value);
                        }} />
                    </Col>
                </Row>
            ) : (null)}
        </>
    );
}

export default SearchCapacityForm;